export const ContactIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4456 4.9382a.3747.3747 0 0 1-.1152.5176l-.085.0537C10.9241 6.9817 8.6624 8.344 7.8333 8.344c-.6475 0-2.2168-.8223-5.4189-2.8379a.3752.3752 0 0 1 .4-.6348C6.388 7.1218 7.5159 7.594 7.8333 7.594c.4814 0 2.167-.9146 5.0107-2.7183l.084-.0537a.3767.3767 0 0 1 .5176.1162ZM16 3.45v9.1A1.45 1.45 0 0 1 14.55 14H1.45A1.45 1.45 0 0 1 0 12.55V3.45A1.45 1.45 0 0 1 1.45 2h13.1A1.45 1.45 0 0 1 16 3.45Zm-.7955 0a.6555.6555 0 0 0-.6547-.6547H1.45a.6554.6554 0 0 0-.6547.6547v9.1a.6554.6554 0 0 0 .6547.6547h13.1a.6554.6554 0 0 0 .6547-.6547Z"
      fill="currentColor"
    />
  </svg>
);
